import { translations } from "./../providers/I18n/translations"
import { parseApiError } from "./http/utils"

export const fetchTranslations = async () => {
  // Use translations.ts file when running storybook
  if (process.env.STORYBOOK_ENV) {
    return { ...translations.EN }
  }
  const res = await fetch("/translation/h3-planning/en")
  return res.json()
}

export const uploadTranslations = async (file: File) => {
  const body = new FormData()
  body.append("file", file)
  const res = await fetch("/translation/h3-planning/en/upload/file", {
    method: "PUT",
    body,
  })
  if (!res.ok) {
    const e = await parseApiError(res)
    throw e
  } else {
    return res.json()
  }
}
